import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, Observable, of, switchMap } from 'rxjs';

import { selectCompanyLocale } from '@public-page/store/company';
import { CustomAsyncPipe } from '@modules/shared/pipes';
import { reformatNumberWithLocale } from '@modules/core/utils';

import { Locale } from '@paymash/local-sdk/models/backend/company/locale';

@Pipe({
  name: 'formatMoney',
})
export class FormatMoneyPipe implements PipeTransform {
  private asyncPipe: CustomAsyncPipe;
  value$!: Observable<string>;

  constructor(private store: Store, private cdr: ChangeDetectorRef) {
    this.asyncPipe = new CustomAsyncPipe(this.cdr);
  }

  transform(value: unknown): unknown {
    const valuePrice = Number(value);

    this.value$ = this.store.select(selectCompanyLocale).pipe(
      filter((value) => value !== undefined),
      switchMap((locale): Observable<string> => {
        return of(
          `${(locale as Locale).currency}\u00a0${reformatNumberWithLocale(valuePrice, locale?.numberFormatString as string)}`
        );
      })
    );

    return this.asyncPipe.transform(this.value$);
  }
}
